<app-view-item *ngIf="readonly" [text]="selected?.code" [tabindex]="tabindex"></app-view-item>
<div class="purchaser-select-container" *ngIf="!readonly">
  <nz-select #selector nzShowSearch nzServerSearch [nzAllowClear]="nzAllowClear" [nzBackdrop]="addBackdrop"
    [nzFilterOption]="nzFilterOption" (nzOnSearch)="onSearch($event)" (nzOpenChange)="onDropdownOpenChange($event)"
    [nzCustomTemplate]="displayTpl" (nzScrollToBottom)="loadMore()" (keydown)="handleKeyDown($event)"
    (click)="handleClick($event)" [(ngModel)]="value" (ngModelChange)="valueChanged($event)"
    [nzDropdownMatchSelectWidth]="false" nzDropdownClassName="dropdownSelect" class="width-100" [nzOptionHeightPx]="40"
    [nzPlacement]="'bottomLeft'" [tabindex]="tabindex" [nzMode]="mode">

    <ng-template #displayTpl let-selected>
      {{ selected.nzLabel }}
    </ng-template>

    <!-- Custom Add New Button at top -->
    <ng-container *aclIf="{ ability: ['m1.4', 'purchaser.create'], mode: 'allOf' }">
      <nz-option *ngIf="!searching && showAddNewButton && !this.NotShowInReport" [nzValue]="''" nzCustomContent>
        <div class="text-center">
          <button type="button" nz-button nzType="primary" class="add-new-button" (click)="$event.stopPropagation(); onAddNewClick($event)">
            <span nz-icon nzType="plus"></span>
            {{ storedInstantData ? " Add New '" + storedInstantData + "'" : ' Add New' }}
          </button>
        </div>
      </nz-option>
    </ng-container>


    <ng-container *ngFor="let o of list">
      <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
        <span>{{ o.code }}</span>
        :
        <span> {{ o.name }}</span>
      </nz-option>
    </ng-container>
  </nz-select>

  <!-- Inline Add Panel -->
  <app-inline-add-panel #inlineAddPanel [config]="purchaserConfig" [visible]="showInlineAddPanel"
    [initialData]="inlineDefaults" (itemCreated)="onPurchaserCreated($event)" (cancelled)="onPurchaserCancelled()"
    (visibleChange)="showInlineAddPanel = $event" (moreDetails)="onPurchaserMoreDetails()"
    (fieldChange)="onFieldChange($event)">
  </app-inline-add-panel>
</div>